import { render, staticRenderFns } from "./dp-svg.vue?vue&type=template&id=3d096aff"
import script from "./dp-svg.vue?vue&type=script&lang=js"
export * from "./dp-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports